import { Injectable } from '@angular/core';
import { App } from 'ionic-angular';
import { CookieService } from 'ngx-cookie';

import { User } from '../../models/user.model';
import { ToastService } from './toast.service';

@Injectable()
export class AuthLocalService {
  private authHeaderKey: string = 'authHeader';
  private currentUserKey: string = 'currentUser';
  private roles: Map<string, string>;

  constructor(private app: App,
              private cookieService: CookieService,
              private toastService: ToastService) {
    this.roles = new Map([
      ['admin', 'ROLE_ADMIN'],
      ['user', 'ROLE_USER']
    ])
  }

  adminPageCanEnter(): boolean {
    return this.securePageCanEnter(['ROLE_ADMIN']);
  }

  getAuthHeader(): string {
    return this.cookieService.get(this.authHeaderKey);
  }

  getCurrentRole(): string {
    return this.getCurrentUser().role;
  }

  getCurrentUser(): User {
    return Object.assign(new User(), this.cookieService.getObject(this.currentUserKey));
  }

  isAdmin(): boolean {
    return this.getCurrentRole() === this.roles.get('admin');
  }

  removeAuthHeader() {
    this.cookieService.remove(this.authHeaderKey);
  }

  removeCurrentUser() {
    this.cookieService.remove(this.currentUserKey);
  }

  securePageCanEnter(authorizedRoles?: string[]): boolean {
    if (AuthLocalService.isAuthorized(this.getCurrentRole(), authorizedRoles)) {
      return true;
    } else {
      setTimeout(() => {
        this.app.getRootNav().setRoot('LoginPage');
      }, 0);
      this.toastService.showError(401);
      return false;
    }
  }

  setAuthHeader(authHeader: string): void {
    this.cookieService.put(this.authHeaderKey, authHeader);
  }

  static isAuthorized(currentRole: string, authorizedRoles: string[] = ['ROLE_ADMIN', 'ROLE_USER']) {
    return authorizedRoles.includes(currentRole);
  }

  setCurrentUser(currentUser: User): void {
    return this.cookieService.putObject(this.currentUserKey, currentUser);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/auth-local.service.ts